import getColumnSearchProps from './getColumnSearchProps'

export default getColumnSearchProps
